<template>
  <div>
    <Filtro @filtro="makeFiltro"></Filtro>

    <List
      :filtro="filtro"
      :realizaFiltro="realizaFiltro"
      @filtroOk="finalizaFiltro"
      :subjectPermission="subjectPermission"
    ></List>
  </div>
</template>

<script>
import Filtro from './../filtros/FiltroCotacoes';
import List from './../lists/ListCotacoes';
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      subjectPermission: 'Cotações',
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
  },
  components: {
    List,
    Filtro,
  },
};
</script>
